<template>
  <div class="report-container">
    <Breadcrumb
    v-if="company || project"
      :company="company"
      :project="project"
      lastname="Report"
      ref="breadcrumb-report"
    />

    <el-card class="box-card select-company-project" style="overflow: inherit">
    <el-form :inline="true">
      <el-form-item label="Company">
        <model-list-select
          :list="dataCompany"
          v-model="company"
          option-value="uid"
          option-text="company_name"
          placeholder="All"
          @input="getProjectData"
        >
        </model-list-select>
      </el-form-item>
      <el-form-item label="Project">
        <model-list-select
          :list="dataProject"
          v-model="project"
          option-value="uid"
          option-text="project_name"
          placeholder="All"
          @input="projectActive"
        >
        </model-list-select>
      </el-form-item>
    </el-form>
  </el-card>

    <el-tabs v-model="reportTabName">
      <el-tab-pane label="Transaction" name="transaction">
        <TransactionReport :company="company" :project="project" client="0" :client-control="true" v-if="reportTabName==='transaction'"/>
      </el-tab-pane>
      <el-tab-pane label="Project" name="project">
        <ProjectReport :company="company" :project="project" client="0" :client-control="true" v-if="reportTabName==='project'"/>
      </el-tab-pane>
      <el-tab-pane label="Monthly Charge" name="monthly-charge">
        <MonthlyCharge :project="project" v-if="reportTabName==='monthly-charge'"/>
      </el-tab-pane>
      <el-tab-pane label="Bank Account" name="bank-account">
        <BankAccountReport :project="project" v-if="reportTabName==='bank-account'"/>
      </el-tab-pane>
      <el-tab-pane label="Compliance" name="compliance">
        <ComplianceReport :project="project" v-if="reportTabName==='compliance'"/>
      </el-tab-pane>
      <el-tab-pane label="Card" name="card">
        <CardReport :project="project" v-if="reportTabName==='card'"/>
      </el-tab-pane>
      <el-tab-pane label="Introducer" name="introducer">
        <IntroducerReport :project="project" v-if="reportTabName==='introducer'"/>
      </el-tab-pane>
      <el-tab-pane label="Debt" name="debt">
        <Debt :project="project" v-if="reportTabName==='debt'"/>
      </el-tab-pane>
      <el-tab-pane label="Account Audit" name="account-audit">
        <AccountAudit :project="project" v-if="reportTabName==='account-audit'"/>
      </el-tab-pane>
      <el-tab-pane label="Firewall" name="firewall">
        <Firewall :project="project" v-if="reportTabName==='firewall'"/>
      </el-tab-pane>
      <el-tab-pane label="Whitelabel Comission" name="whitelabelcomission">
        <WhitelabelComission :company="company" v-if="reportTabName==='whitelabelcomission'"/>
      </el-tab-pane>
      <el-tab-pane label="Active Account" name="active-account">
        <ActiveAccount :project="project" v-if="reportTabName==='active-account'"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ModelListSelect } from "vue-search-select";
import { getCompany } from "@/api/company";
import { getProjectByCompany, projectActive } from "@/api/project";
import Breadcrumb from "@/components/Breadcrumb";
import MonthlyCharge from "./components/monthly-charge-report";
import BankAccountReport from "./components/bank-account-report";
import TransactionReport from "./components/company-transaction-report";
import ProjectReport from "./components/project-report";
import ComplianceReport from "./components/compliance-report";
import IntroducerReport from "./components/introducer-report";
import CardReport from "./components/card-report";
import Debt from "./components/debt";
import AccountAudit from "./components/account-audit-report";
import Firewall from "./components/firewall"
import WhitelabelComission from "./components/whitelabel-comission-report"
import ActiveAccount from "./components/active-account-report"
export default {
  components: {
    Breadcrumb,
    MonthlyCharge,
    BankAccountReport,
    TransactionReport,
    ProjectReport,
    ComplianceReport,
    IntroducerReport,
    ModelListSelect,
    CardReport,
    Debt,
    AccountAudit,
    Firewall,
    WhitelabelComission,
    ActiveAccount
  },
  computed: {
    ...mapGetters(["user_project", "company_uid"]),
    reportRole() {
      return this.roleAuth([this.role.spadmin, this.role.admin]);
    }
  },
  data() {
    return {
      company: "",
      project: "",
      reportTabName: "transaction",
      dataCompany: [],
      dataProject: [],
    };
  },
  methods:{
    getCompanyData() {
      getCompany().then(({ result, data }) => {
        if (result) {
          this.dataCompany = data;
          this.company = this.company_uid;  
          this.getProjectData(this.company)      
        }
      });
    },
    getProjectData(company) {
      this.project = "";
      this.dataProject = [];
      getProjectByCompany(company).then(async({ result, data }) => {
        if (result) {
          this.dataProject = data;
          this.project = this.user_project;
          const selectedCompany = this.dataCompany.find((c) => c.uid === company);
          await this.$store.dispatch("user/setCompany", selectedCompany || {uid: company});
          this.$refs['breadcrumb-report'].reload()
        }
      });
    },
    projectActive(value) {
      this.project = value;
      projectActive(value).then(async ({ result }) => {
        if (result) {
          await this.$store.dispatch("user/getInfo");
          await this.$store.dispatch("user/setProject", {uid: value});
          this.$refs['breadcrumb-report'].reload()
        }
      });
    },
  },
  beforeUpdate() {},
  mounted() {
    this.getCompanyData();
  },
};
</script>


<style lang="scss">
.report-container{
  .select-company-project{
    .el-form-item__content{
      margin-right: 20px;
      min-width: 330px;
    }
  }

}
</style>